export const ORDER_STEPS = [
  "confirmed",
  "packed",
  "shipped",
  "out_for_delivery",
  "delivered",
];

export const ADMIN_ORDER_STATUS_META = {
  pending: { label: "Pending", color: "#c0392b" },
  processing: { label: "Processing", color: "#e8a020" },
  packed: { label: "Packed", color: "#0f5b8d" },
  shipped: { label: "Shipped", color: "#1a6b45" },
  delivered: { label: "Delivered", color: "#2d6a4f" },
  cancelled: { label: "Cancelled", color: "#7a4b3a" },
  refunded: { label: "Refunded", color: "#7a4b3a" },
};

export const ADMIN_PAYMENT_STATUS_META = {
  pending: { label: "Pending Payment", color: "#c0392b" },
  paid: { label: "Paid", color: "#2d6a4f" },
  failed: { label: "Failed", color: "#7a4b3a" },
  refunded: { label: "Refunded", color: "#0f5b8d" },
};

export const ADMIN_ORDER_STATUS_OPTIONS = [
  "pending",
  "processing",
  "packed",
  "shipped",
  "delivered",
  "cancelled",
];

export const ADMIN_ORDER_TIMELINE_STAGES = [
  "pending",
  "processing",
  "packed",
  "shipped",
  "delivered",
];
